import { render } from "./CardTemplate.vue?vue&type=template&id=b38b26bc&scoped=true"
import script from "./CardTemplate.vue?vue&type=script&lang=js"
export * from "./CardTemplate.vue?vue&type=script&lang=js"

import "./CardTemplate.vue?vue&type=style&index=0&id=b38b26bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b38b26bc"]])

export default __exports__